import React from 'react';
import { Stack, Chip } from '@mui/material';
import { Person, CalendarToday } from '@mui/icons-material';
import { NoteView } from '../../../../../../services/RefundService/types/refundTypes';
import { formatDate } from '../utils';

interface NoteMetadataSectionProps {
  note: NoteView;
  canDelete: boolean;
}

export const NoteMetadataSection: React.FC<NoteMetadataSectionProps> = ({ note, canDelete }) => (
  <Stack direction="row" spacing={2} sx={{ mb: 3 }}>
    <Chip
      icon={<Person />}
      label={note.addedBy || 'Unknown User'}
      variant="outlined"
      sx={{
        borderColor: canDelete ? '#10b981' : '#3b82f6',
        color: canDelete ? '#10b981' : '#3b82f6',
        '& .MuiChip-icon': {
          color: canDelete ? '#10b981' : '#3b82f6',
        },
      }}
    />
    <Chip
      icon={<CalendarToday />}
      label={formatDate(note.addDate)}
      variant="outlined"
      sx={{
        borderColor: '#64748b',
        color: '#64748b',
        '& .MuiChip-icon': {
          color: '#64748b',
        },
      }}
    />
    {canDelete && (
      <Chip
        label="Your Note"
        size="small"
        sx={{
          backgroundColor: '#dcfce7',
          color: '#166534',
          fontWeight: 500,
        }}
      />
    )}
  </Stack>
);

export default NoteMetadataSection;
